/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RespondToAppraisal201ResponseData
 */
export interface RespondToAppraisal201ResponseData {
    /**
     * 
     * @type {string}
     * @memberof RespondToAppraisal201ResponseData
     */
    outcome?: string;
    /**
     * 
     * @type {string}
     * @memberof RespondToAppraisal201ResponseData
     */
    outcomeLabel?: string;
}

/**
 * Check if a given object implements the RespondToAppraisal201ResponseData interface.
 */
export function instanceOfRespondToAppraisal201ResponseData(value: object): value is RespondToAppraisal201ResponseData {
    return true;
}

export function RespondToAppraisal201ResponseDataFromJSON(json: any): RespondToAppraisal201ResponseData {
    return RespondToAppraisal201ResponseDataFromJSONTyped(json, false);
}

export function RespondToAppraisal201ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RespondToAppraisal201ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'outcome': json['outcome'] == null ? undefined : json['outcome'],
        'outcomeLabel': json['outcomeLabel'] == null ? undefined : json['outcomeLabel'],
    };
}

export function RespondToAppraisal201ResponseDataToJSON(json: any): RespondToAppraisal201ResponseData {
    return RespondToAppraisal201ResponseDataToJSONTyped(json, false);
}

export function RespondToAppraisal201ResponseDataToJSONTyped(value?: RespondToAppraisal201ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'outcome': value['outcome'],
        'outcomeLabel': value['outcomeLabel'],
    };
}

